import KendoGridMixin from './KendoGridMixin'

export default {
    name: 'kendo-grid',
    mixins: [ KendoGridMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/index.js